import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n"; // Import i18n configuration
import "./styles/globals.css";
import App from "./App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<React.StrictMode>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</React.StrictMode>,
);
